import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries, HTTP_FILE } from "@/api/http-common";

export function callApiSearchHoSoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.SEARCH,
    method: "POST",
    data: payload,
  });
}

export function callApiTaoHoSoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayChiTietHoSoCongViec(Id) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + Id,
    method: "GET",
  });
}

export function callApiSuaHoSoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + payload.Id,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatVanBan(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.HSCV_UPDATE_VB + payload.Id,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapNhatFile(payload) {
  return HTTP_FILE({
    url: ENDPOINT.HO_SO_CONG_VIEC.HSCV_UPDATE_FILE + payload.Id,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiThemYKienXuLy(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.Y_KIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaYKienXuLy(payload) {
  return HTTP({
    url: `${ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.Y_KIEN}/${
      payload.Id
    }`,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaYKienXuLy(payload) {
  return HTTP({
    url: `${ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.Y_KIEN}/${
      payload.Id
    }`,
    method: "DELETE",
    asyncLoading: true,
  });
}

export function callApiXoaHoSoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME,
    method: "DELETE",
    data: payload,
  });
}

export function callApiExportHoSoCongViec(payload) {
  return HTTP_FILE({
    url: ENDPOINT.HO_SO_CONG_VIEC.EXPORT,
    method: "POST",
    data: payload,
  });
}

export function callApiPhanXuLy(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.Id +
      ENDPOINT.HO_SO_CONG_VIEC.PHAN_XU_LY,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiTraLai(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.TRA_LAI,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiMoLai(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.IdProcess +
      ENDPOINT.HO_SO_CONG_VIEC.MO_LAI,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiKetThuc(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.IdProcess +
      ENDPOINT.HO_SO_CONG_VIEC.KET_THUC,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDoiTuongDuocTraLai(Id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      Id +
      ENDPOINT.HO_SO_CONG_VIEC.LAY_DOI_TUONG_DUOC_TRA_LAI,
    method: "POST",
  });
}

export function callApiLayTreeDonVi(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      ENDPOINT.HO_SO_CONG_VIEC.GET_TREE_DON_VI +
      `?${buildQueries(payload)}`,
    method: "GET",
  });
}

export function callApiSetDaXuLy(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.id +
      ENDPOINT.HO_SO_CONG_VIEC.SET_DA_PHAN_XU_LY,
    method: "POST",
    params: payload,
  });
}

export function callApiSetDangXuLy(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload +
      ENDPOINT.HO_SO_CONG_VIEC.SET_DANG_PHAN_XU_LY,
    method: "POST",
  });
}

export function callApiCapNhatTHTH(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.Id +
      ENDPOINT.HO_SO_CONG_VIEC.CAP_NHAT_THTH,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiThuHoiHoSoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.THU_HOI,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayTreePhanXuLy(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      ENDPOINT.HO_SO_CONG_VIEC.GET_TREE_PHAN_XU_LY +
      `?${buildQueries(payload)}`,
    method: "GET",
  });
}

export function callApiLayLichSuThuHoi(Id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      Id +
      ENDPOINT.HO_SO_CONG_VIEC.LICH_SU_THU_HOI,
    method: "GET",
  });
}

export function callApiLayLichSuTraLai(Id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      Id +
      ENDPOINT.HO_SO_CONG_VIEC.LICH_SU_TRA_LAI,
    method: "GET",
  });
}

export function callApiLayLichSuCapNhatTinhHinhThucHien(Id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      Id +
      ENDPOINT.HO_SO_CONG_VIEC.LICH_SU_CAP_NHAT_TINH_HINH_THUC_HIEN,
    method: "GET",
  });
}

export function callApiLayLichSuPhanXuLy(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.id +
      ENDPOINT.HO_SO_CONG_VIEC.LICH_SU_PHAN_XU_LY,
    method: "POST",
    data: payload,
  });
}

export function callApiLayLuongXuLy(id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      id +
      ENDPOINT.HO_SO_CONG_VIEC.GET_LUONG_XU_LY,
    method: "GET",
  });
}

export function callApiGetCountList(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + ENDPOINT.HO_SO_CONG_VIEC.COUNT,
    method: "GET",
    params: payload,
  });
}

export function callApiGetTreeDaPhanXuLy(payload) {
  let keySearch = {
    keySearch: payload.keySearch,
  };
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.id +
      ENDPOINT.HO_SO_CONG_VIEC.GET_TREE_DA_PHAN_XU_LY +
      `?${buildQueries(keySearch)}`,
    method: "POST",
  });
}

export function callApiDuyetHSCV(id) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.NAME + id + ENDPOINT.HO_SO_CONG_VIEC.DUYET,
    method: "POST",
  });
}

export function callApiHuyDuyetHSCV(id) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME + id + ENDPOINT.HO_SO_CONG_VIEC.HUY_DUYET,
    method: "PUT",
  });
}

export function callApiCapNhatVaiTroTreePXL(payload) {
  return HTTP({
    url:
      ENDPOINT.HO_SO_CONG_VIEC.NAME +
      payload.Id +
      ENDPOINT.HO_SO_CONG_VIEC.CAP_NHAT_VAI_TRO_TREE_PXL,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXinYKien(payload) {
  return HTTP({
    url: ENDPOINT.HO_SO_CONG_VIEC.XIN_Y_KIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiDanhSachYKienPhanTrang(payload) {
  return HTTP({
    url: `${ENDPOINT.HO_SO_CONG_VIEC.DANH_SACH_Y_KIEN}/${payload.id}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

